
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DownloadUrls } from '../config/types';
import Footer from '../components/Footer.vue';
import MobileHeaderSection from './MobileHeaderSection.vue';
import MobileMainSection from './MobileMainSection.vue';
import { collectDownload } from '@/config/collect';
import { isIOS } from '@/utils/tool';
import {
  downloadAndroidApp,
  downloadIosApp,
  fetchIosChannelConfig,
} from '../utils/appDownload';

@Component({
  components: { Footer, MobileHeaderSection, MobileMainSection },
})
export default class MobilePage extends Vue {
  @Prop({ required: true }) public downloadUrls!: DownloadUrls;
  @Prop({ default: false }) public hideList!: boolean;
  @Prop({ default: false }) public showAppInfo!: boolean;
  @Prop({ default: false }) public isBaiduDeveloper!: boolean;
  @Prop({ default: true }) public showAddress!: boolean;
  @Prop({ default: '' }) public developerName!: string;
  @Prop({ default: false }) public collectEnabled!: boolean;
  /** 是否请求 iOS 渠道配置，由父组件按页面开启 */
  @Prop({ default: false }) public iosChannelEnabled!: boolean;

  /** 接口下发的 iOS 跳转地址（含渠道信息） */
  public iosDownloadUrl = '';
  /** 接口下发的 OpenInstall appKey */
  public iosAppKey = '';

  /** 配置隐藏，或地址栏带 game_id 时隐藏游戏列表 */
  get shouldHideList() {
    const gameId = (this as any).$route.query.game_id;
    const hasGameId = Array.isArray(gameId) ? !!gameId[0] : !!gameId;
    return this.hideList || hasGameId;
  }

  public mounted() {
      // downUrl 指向非苹果官网时直接跳
    if (this.iosChannelEnabled && isIOS()) {
      this.fetchIosChannelConfig();
    }
  }

  public async fetchIosChannelConfig() {
    const result = await fetchIosChannelConfig();
    if (result.redirected) {
      return;
    }
    this.iosDownloadUrl = result.iosDownloadUrl;
    this.iosAppKey = result.iosAppKey;
  }

  public handleDownload() {
    if (this.collectEnabled) {
      collectDownload('APP');
    }
    if (isIOS()) {
      downloadIosApp({
        iosDownloadUrl: this.iosDownloadUrl,
        iosAppKey: this.iosAppKey,
      });
      return;
    }
    downloadAndroidApp(this.downloadUrls);
  }
}
